<ui-bottom-sheet
  [open]="sheetOpen()"
  [title]="title() | translate | titlecase"
  [stableHeight]="searchEnabled()"
  (closeEmit)="close()">

  <div sheet-content>
    @if (searchEnabled()) {
      <div class="sheet-search-wrapper">
        <ui-search
          [placeholder]="'COMMON.SEARCH' | translate"
          [heightPx]="40"
          [debounceMs]="0"
          [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        />
      </div>
    }

    <div class="sheet-options-list">
      @for (option of filteredOptions(); track option.value) {
        @if (option.group && ($index === 0 || option.group !== filteredOptions()[$index - 1].group)) {
          <div class="sheet-group-header">{{ option.group }}</div>
        }
        <label class="sheet-option"
               [class.disabled]="option.disabled"
               (click)="onOptionTap(option)">
          @if (isMultiple()) {
            <span class="custom-checkbox"
                  [class.checked]="isSelected(option.value)">
              @if (isSelected(option.value)) {
                <mat-icon>check</mat-icon>
              }
            </span>
          } @else {
            <span class="custom-radio"
                  [class.checked]="isSelected(option.value)">
            </span>
          }
          @if (option.image) {
            <img class="sheet-option-img" [src]="option.image" />
          }
          <span class="option-label"
                [class.selected]="isSelected(option.value)">
            {{ option.viewValue }}
          </span>
        </label>
      } @empty {
        <div class="sheet-empty-state">
          @if (searchQuery()) {
            {{ 'COMMON.SEARCH_NO_RESULTS' | translate }}
          } @else {
            {{ 'COMMON.SEARCH_START_TYPING' | translate }}
          }
        </div>
      }
    </div>
  </div>

  @if (isMultiple()) {
    <div sheet-actions class="w-100">
      <ui-button
        class="w-100"
        [text]="('COMMON.APPLY' | translate) +
          (localSelection().length ? ' (' + localSelection().length + ')' : '')"
        type="primary"
        size="l"
        [disabled]="!localSelection().length"
        (clickAction)="apply()"
      />
    </div>
  }
</ui-bottom-sheet>
